import {
  DefaultProjectorFn,
  MemoizedSelector,
  createSelector,
} from '@ngrx/store';

import { ETransactionType } from '@literax/enums/document.enum';
import { WorkspaceState } from '../workspace.state';

export const DocumentSelectors = (
  storeFeature: MemoizedSelector<
    // eslint-disable-next-line @typescript-eslint/ban-types
    object,
    WorkspaceState,
    DefaultProjectorFn<WorkspaceState>
  >
) => ({
  workingDocument: createSelector(
    storeFeature,
    (state: WorkspaceState) => state?.document
  ),
  status: createSelector(
    storeFeature,
    (state: WorkspaceState) => state?.document?.status?.key
  ),
  transaction: createSelector(
    storeFeature,
    (state: WorkspaceState) =>
      ETransactionType[state?.document?.transactionType]
  ),
  signatureVerification: createSelector(
    storeFeature,
    (state: WorkspaceState) =>
      state?.document?.signingConfiguration?.signatureVerificationTypeId
  ),
  errorDocument: createSelector(
    storeFeature,
    (state: WorkspaceState) => state?.errorMessage
  ),
  /** The resolved outcome of a failed guest-link request, or `null` (FR-030, D-13). */
  linkOutcome: createSelector(
    storeFeature,
    (state: WorkspaceState) => state?.linkOutcome ?? null
  ),
  /**
   * The guest's own credential, or `null` for an authenticated caller.
   *
   * The same workspace value the button bar already reads; exposed as a selector so the download
   * effect can present it on the download-link request (FR-032, D-14).
   */
  guestToken: createSelector(
    storeFeature,
    (state: WorkspaceState) => state?.guestToken ?? null
  )
});
